const Note: React.FC<{ fields: { title: string; body: string } }> = ({ fields }) => {
  return (
    <div className="p-3 background-digital-light-grey w-100">
      <h5 className="mb-3">{fields.title}</h5>
      <p className="text-grey">{fields.body}</p>
    </div>
  );
};

export default Note;
